<template>
<div class="info-summary">
  <!-- Info tabs -->
  <el-inline>
    <div
      class="order-tab animation"
      :class="{
        'order-tab-selected': infoTab === 'info'
      }"
      @click="infoTab = 'info'"
      >
      {{__('Info')}}
    </div>
    <div
      class="order-tab animation"
      :class="{
        'order-tab-selected': infoTab === 'specs'
      }"
      @click="infoTab = 'specs'"
      >
      {{__('Technical specification')}}
    </div>
  </el-inline>

  <br>

  <!-- Content -->
  <transition-group name="slide-fade">
    <div key="info" class="animation" v-if="infoTab === 'info'">
      <b>{{__('New unique innovation for riders. A wearable that helps you improve your seat quickly which results in more effective training and less strain on the horse. Learning made easy.')}}</b>
      <br><br>
      <b>{{__('Including:')}}</b>
      <p>HeadQ<br>{{ __('Silicone bracket for helmet') }}<br>{{ __('Protective small bag') }}<br>{{ __('Induction charger with cord') }}</p>

      <!-- Made in Sweden -->
      <div class="made-in-sweden">
        <div>
          <svg width="35px" height="29px" viewBox="0 0 35 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Light-Annika" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="order-copy-3" transform="translate(-547.000000, -734.000000)">
                      <g id="Group-5" transform="translate(547.000000, 730.000000)">
                          <g id="Group-4" transform="translate(0.000000, 4.000000)">
                              <rect id="Rectangle" fill="#FFE630" x="0" y="0" width="35" height="29" rx="5"></rect>
                              <path d="M0,11 L0,3.5 C-2.36723813e-16,1.56700338 1.56700338,3.55085719e-16 3.5,0 L9.03544443,0 C9.01208598,0.163301492 9,0.33023933 9,0.5 L9,11 L0,11 Z M0,18 L9,18 L9,28.5 C9,28.6697607 9.01208598,28.8366985 9.03544443,29 L3.5,29 C1.56700338,29 2.36723813e-16,27.4329966 0,25.5 L0,18 Z M35,11 L16,11 L16,0.5 C16,0.33023933 15.987914,0.163301492 15.9645556,2.49800181e-16 L31.5,0 C33.4329966,-3.55085719e-16 35,1.56700338 35,3.5 L35,11 Z M35,18 L35,25.5 C35,27.4329966 33.4329966,29 31.5,29 L15.9645556,29 C15.987914,28.8366985 16,28.6697607 16,28.5 L16,18 L35,18 Z" id="Combined-Shape" fill="#056EC6"></path>
                          </g>
                      </g>
                  </g>
              </g>
          </svg>
        </div>
        <div class="caption">{{ __('Developed, designed and manufactured in Sweden') }}</div>
      </div>
    </div>
    <div key="specs" class="animation" v-else-if="infoTab === 'specs'">

      <b>{{ __('Attachment') }}</b>
      <p>{{ __('Stretchy flexible attachment of silicone for all types of helmets.') }}</p>

      <b>{{ __('Battery') }}</b>
      <p>{{ __('8 hours of riding') }}</p>
      <!--
      <p>3.7V 180mAh</p>
      -->

      <b>{{ __('Bluetooth') }}</b>
      <p>{{ __('5.0 (low energy)') }}</p>

      <b>{{ __('Outer shell') }}</b>
      <p>{{ __('ABS. Size 42x32x11.5 mm.') }}</p>

      <b>{{ __('Bag') }}</b>
      <p>{{ __('Water resistant protective bag with format insert and mesh pocket, zipper and carabiner. Dimensions 80x80x30 mm.') }}</p>

      <b>{{ __('Induction charger') }}</b>
      <p>{{ __('Induction charger with 120cm standard USB cable.') }}</p>

      <b>{{ __('Package') }}</b>
      <p>{{ __('Size 203x142x50mm') }}</p>

      <b>{{ __('App') }}</b>
      <p>{{ __('Available for Android & iOS through Google Play/App store.') }}</p>

      <br>
      <!-- CE -->
      <div class="icon-wrapper">
        <svg width="33px" height="24px" viewBox="0 0 33 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="order-copy-4" transform="translate(-606.000000, -898.000000)" fill="#000000">
                    <path d="M629.248975,908 L637,908 L637,912 L629.248975,912 C630.198936,915.744036 633.756499,918.526316 638,918.526316 C638.338009,918.526316 638.671666,918.508663 639,918.474278 L639,921.988862 C638.806588,921.996262 638.612115,922 638.416667,922 C631.006846,922 625,916.627417 625,910 C625,903.372583 631.006846,898 638.416667,898 C638.612115,898 638.806588,898.003738 639,898.011138 L639,901.525722 C638.671666,901.491337 638.338009,901.473684 638,901.473684 C633.756499,901.473684 630.198936,904.255964 629.248975,908 Z M620,901.525722 C619.671666,901.491337 619.338009,901.473684 619,901.473684 C614.029437,901.473684 610,905.291046 610,910 C610,914.708954 614.029437,918.526316 619,918.526316 C619.338009,918.526316 619.671666,918.508663 620,918.474278 L620,921.988862 C619.806588,921.996262 619.612115,922 619.416667,922 C612.006846,922 606,916.627417 606,910 C606,903.372583 612.006846,898 619.416667,898 C619.612115,898 619.806588,898.003738 620,898.011138 L620,901.525722 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </svg>
        <div style="width: 20px" />
        <!-- RoHS -->
        <svg width="50px" height="29px" viewBox="0 0 27 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="order-copy-4" transform="translate(-713.000000, -899.000000)">
                    <g id="Group-8" transform="translate(713.000000, 899.000000)">
                        <g id="Group-7" transform="translate(8.000000, 0.000000)">
                            <rect id="Rectangle" fill="#000000" x="1" y="14" width="10" height="3"></rect>
                            <g id="Group-5">
                                <path d="M0.5,12.5 L11.5,0.5" id="Line" stroke="#000000" stroke-width="0.5" stroke-linecap="square"></path>
                                <path d="M11.5,12.5 L0.5,0.5" id="Line" stroke="#000000" stroke-width="0.5" stroke-linecap="square"></path>
                                <polygon id="Path-2" stroke="#000000" stroke-width="0.5" points="7.83605913 10.3667126 4.16374833 10.3667126 3.35138506 2.48786089 8.74859798 2.48786089"></polygon>
                                <path d="M2.90858116,2.37417462 C3.05618246,2.37417462 3.20378376,2.37417462 3.35138506,2.37417462 C4.09980093,0.836083679 8.4915114,1.24680976 8.74859798,2.37417462" id="Path-3" stroke="#000000" stroke-width="0.5"></path>
                                <rect id="Rectangle" fill="#000000" x="5.4" y="4.2" width="2" height="1"></rect>
                                <rect id="Rectangle" fill="#000000" x="8.3" y="3.1" width="1.1" height="1.1"></rect>
                                <rect id="Rectangle" fill="#000000" x="4" y="10.4" width="1" height="1"></rect>
                                <rect id="Rectangle" fill="#000000" x="4" y="1.2" width="1" height="1.1"></rect>
                                <rect id="Rectangle" fill="#000000" x="5.4" y="1" width="1.8" height="1"></rect>
                                <circle id="Oval" fill="#000000" cx="9" cy="2" r="1"></circle>
                                <circle id="Oval" fill="#000000" cx="8" cy="10" r="1"></circle>
                                <circle id="Oval" fill="#FFFFFF" cx="8" cy="10" r="1"></circle>
                            </g>
                        </g>
                        <text id="RoHS" font-family="PTSans-Bold, PT Sans" font-size="12" font-weight="bold" fill="#000000">
                            <tspan x="0" y="28">RoHS</tspan>
                        </text>
                    </g>
                </g>
            </g>
        </svg>
      </div>
    </div>
  </transition-group>
</div>
</template>
<script>
export default {
  data () {
    return {
      infoTab: 'info'
    }
  }
}
</script>
<style lang="less" scoped>
  @import '~style/variables.less';

  .info-summary {
    p {
      margin-top: 0px;
    }
  }

  .made-in-sweden {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-top: 20px;

    .caption {
      font-size: 14px;
      margin-left: 15px;
    }
  }

  .order-tab {
    color: @color-brand;
    margin-right: 30px;
    cursor: pointer;
    font-weight: 500;
    border-bottom: 3px solid #ffffff;
  }

  .order-tab-selected {
    font-weight: 500;
    border-bottom: 3px solid @color-brand;
  }

  .icon-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }

  .slide-fade-leave-active {
    transition: none;
  }

  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(-10px);
    opacity: 0;
  }
</style>
